import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../utils/api';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState({
    primary_color: '#007bff',
    secondary_color: '#6c757d',
    font_family: 'Arial, sans-serif',
  });

  useEffect(() => {
    // Fetch published theme on mount
    const fetchTheme = async () => {
      try {
        const response = await api.get('/theme');
        setTheme(response.data);
        applyTheme(response.data);
      } catch (error) {
        console.error('Failed to fetch theme:', error);
      }
    };
    fetchTheme();
  }, []);

  const applyTheme = (themeData) => {
    document.documentElement.style.setProperty('--primary-color', themeData.primary_color);
    document.documentElement.style.setProperty('--secondary-color', themeData.secondary_color);
    document.documentElement.style.setProperty('--font-family', themeData.font_family);

    if (themeData.font_family) {
      document.body.style.fontFamily = themeData.font_family;
    }
  };

  const updateTheme = (newTheme) => {
    setTheme(newTheme);
    applyTheme(newTheme);
  };

  const value = {
    theme,
    updateTheme,
  };

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};
